import axiosInstance from './axiosInstance';

export type RawArchiveDatePrecision = 'year' | 'month' | 'day' | 'time' | 'unknown';

export interface ParsedArchiveItem {
  client_id: string;
  selected: boolean;
  title: string;
  description: string;
  timestamp: string;
  date_text: string;
  date_precision: RawArchiveDatePrecision;
  lnks: string;
  tags: string[];
  main_category1_id: number | null;
  main_category2_id: number | null;
  main_category3_id: number | null;
  confidence: number;
  source_excerpt: string;
  warnings: string[];
  errors: string[];
}

export interface RawArchiveParseResponse {
  topic_area_id: number;
  provider: string;
  items: ParsedArchiveItem[];
  warnings: string[];
  credits?: {
    text_length: number;
    charged: number;
    balance_before: number;
    balance: number;
  };
}

export interface RawArchiveParseRequest {
  topicAreaId: number;
  rawText?: string;
  file?: File | null;
  provider?: string;
  maxItems?: number;
}

export interface RawArchiveBulkCreateResponse {
  created_count: number;
  created_ids: number[];
  failed: Array<{ index: number; errors: string[] }>;
}

export const parseRawArchive = async (request: RawArchiveParseRequest): Promise<RawArchiveParseResponse> => {
  const formData = new FormData();
  formData.append('topic_area_id', String(request.topicAreaId));
  if (request.rawText) formData.append('raw_text', request.rawText);
  if (request.file) formData.append('file', request.file);
  if (request.provider) formData.append('provider', request.provider);
  if (request.maxItems) formData.append('max_items', String(request.maxItems));

  const response = await axiosInstance.post('/api/raw-archive/parse', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};

export const bulkCreateRawArchive = async (
  topicAreaId: number,
  items: ParsedArchiveItem[]
): Promise<RawArchiveBulkCreateResponse> => {
  const response = await axiosInstance.post('/api/raw-archive/bulk-create', {
    topic_area_id: topicAreaId,
    items: items.map(item => ({
      title: item.title,
      description: item.description,
      timestamp: item.timestamp,
      lnks: item.lnks,
      main_category1_id: item.main_category1_id,
      main_category2_id: item.main_category2_id,
      main_category3_id: item.main_category3_id,
      tags: item.tags
    }))
  });
  return response.data;
};
